import $ from 'jquery';

export default function(id, speed) {
  speed = speed || 'fast';
  $(document.getElementById(id)).slideToggle(speed);
};




// WEBPACK FOOTER //
// ./src/scripts/modules/toggle-visibility.js